import { useEffectOnce } from './useEffectOnce';

/**
 * Hook that runs a callback when the component unmounts
 * @param callback Function to call when the component unmounts
 */
export const useOnUnmount = (callback: () => void): void => {
  useEffectOnce(() => callback);
};
